// extracted by mini-css-extract-plugin
module.exports = {"forkIcon":"ForkProducts_forkIcon__2ru4d","title":"ForkProducts_title__SVMX1","popover":"ForkProducts_popover__rLdxv","btn":"ForkProducts_btn__SEJWr"};